export default __webpack_public_path__ + "static/media/brand6.5821e652.svg";